export enum FpLoggerNoiseTabs {
  Histogram = 'loadHistogram',
  SignalSpectrum = 'loadSignalSpectrum',
  LeakScore = 'loadLoggerDateLeakScoreChartData',
  AIPredictor = 'loadLoggerDateLeakScoreMLChartData',
  MinNoise = 'loadLoggerDateLowestDecibelChartData',
  Spread = 'loadLoggerSpreadChartData',
  Summary = 'summary',
  Comments = 'comments',
  Pictures = 'fetchLoggerDetailsBySerialNo',
}
